/* Magic Milk - zentrales Stilblatt, Ring-Vermessung, Nach-oben-Knopf, Text-Effekt.
   Laedt ZULETZT (siehe theme.liquid).

   Merts Regeln, die hier durchgesetzt werden:
   - 15.08.: "Das sieht nach AI aus" -> keine Farbverlauf-Knoepfe, kein Leuchtschein,
     keine schwebenden Karten.
   - 15.08.: Nach-oben-Knopf "ohne hintergrund und glas optik, verschiebbar"
     -> Glas statt Rot, per Finger/Maus frei plazierbar, Position wird gemerkt.

   STORY-RING - drei echte Ursachen (alle gemessen):
     a) `inset` und danach `inset:auto` -> hebt left/top wieder auf.
     b) Drehung lag auf dem <svg>; ein gedrehtes Element hat eine gedrehte
        Bounding-Box (74er-Quadrat misst bei 45 Grad rund 105). Drehung sitzt
        jetzt auf einer inneren <g>-Gruppe (mm-story.js).
     c) Theme setzt `svg{max-width:100%}` -> deckelte die Breite auf 68 statt 74.
   Groesse/Lage per JS in festen Pixeln, nicht per CSS-calc. */
(function () {
  var K = 'cubic-bezier(.22,.61,.36,1)';
  var ROT = '#E5142A', ROT_DUNKEL = '#C40F22';
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var P = 'html body ';
  var KNOEPFE = [
    '#mmSL .mmSL-knopf', '.mmSek .mmKnopf', '#mmGal .mmGknopf',
    '#mmPx .mmPxKnopf', '#mmSt .mmStCta', '#mmN2 .mmN2cta', '#mmNavi .mmCta'
  ].map(function (s) { return P + s; }).join(',');

  var stilCss = [
    KNOEPFE + '{background:' + ROT + '!important;background-image:none!important;',
      'box-shadow:0 1px 2px rgba(0,0,0,.22)!important;color:#fff!important;',
      'border-radius:8px!important;text-shadow:none!important;',
      'transition:background .2s ease,transform .12s ' + K + '!important}',
    '@media (hover:hover){' + KNOEPFE + ':hover{background:' + ROT_DUNKEL + '!important;',
      'transform:none!important;box-shadow:0 1px 2px rgba(0,0,0,.22)!important}}',
    KNOEPFE + ':active{transform:translateY(1px)!important}',

    /* Nach-oben-Knopf ist am 19.08.2026 entfallen (Mert: "pfeil weg").
       Sein Glas-Aussehen stand hier - entfernt, weil es nichts mehr trifft.
       Die Funktion verschiebbar() weiter unten laeuft ins Leere und tut
       nichts; sie bleibt stehen, falls der Knopf zurueckkommt. */

    P + '#mmN2 .mmN2marke{background:' + ROT + '!important;background-image:none!important;',
      'box-shadow:none!important}',
    P + '#mmReiter .mmRGleiter{background:' + ROT + '!important;',
      'background-image:none!important;box-shadow:none!important;border-radius:9px!important}',
    P + '#mmFaq2 .mmF2knopf::before{background:' + ROT + '!important;background-image:none!important}',
    P + '#mmFaq2 .mmF2auge{background:none!important;',
      '-webkit-text-fill-color:' + ROT + '!important;color:' + ROT + '!important}',
    P + '#mmSL li.hell{text-shadow:none!important}',
    P + '#mmPx .mmPxTitel h2{text-shadow:0 4px 18px rgba(0,0,0,.6)!important}',

    P + '.st_story-circle .mmRing{max-width:none!important;max-height:none!important;',
      'min-width:0!important;min-height:0!important}',
    P + '.st_story-circle .mmRing path{stroke-width:3.2!important}',
    P + '.st_story-circle .mmRing path.offen{stroke:rgba(229,20,42,.5)!important}',
    P + '.st_story-circle .mmRing path.fertig{stroke:rgba(140,128,134,.26)!important}',

    '@media (hover:hover){',
      P + '.mmBento figure:hover,' + P + '.mmVier figure:hover,',
      P + '.st_card:hover,' + P + '.resource-card:hover,' + P + '.product-card:hover{',
      'transform:none!important;box-shadow:0 2px 8px rgba(0,0,0,.16)!important}}',
    P + '.shopify-section .button:not(.button--secondary),',
    P + '.shopify-section .btn,',
    P + '.shopify-section button[name="add"]{background-image:none!important;',
      'box-shadow:none!important;outline:0!important}',

    /* 25.08.2026, Mert: "story animation ploppen logo runterfallen lassen wie
       davor". Das Logo faellt von oben in die Kopfzeile - aber ERST, wenn die
       Story-Kreise fertig geploppt sind. Rechnung aus dem Protokoll vom
       23.08.: vier Kreise, 95 ms Versatz, je 620 ms, der letzte Name 180 ms
       spaeter -> fertig nach 1085 ms. Darum 1,15 s Verzoegerung: knapp
       danach, ohne Loch dazwischen. */
    /* 25.08.2026, Mert: "logo faellt nicht gut runter. das muss abprallen".
       Vorher war es ein reiner Fall mit Beschleunigungskurve - unten einfach
       Schluss. Jetzt ein echtes Abprallen: das Logo faellt, setzt auf, springt
       drei Mal mit abnehmender Hoehe nach und kommt dann zur Ruhe.
       Zwei Dinge machen es glaubwuerdig:
         1. Jeder Sprung erreicht rund 40 % des vorherigen (38 -> 14 -> 6 -> 2 px)
            und dauert kuerzer - so verhaelt sich ein fallender Koerper wirklich.
         2. Beim Aufsetzen wird das Logo kurz gestaucht und beim Abheben wieder
            gestreckt. Ohne das wirkt jeder Aufprall wie ein harter Schnitt.
       `transform-origin` liegt unten, sonst staucht es um die Mitte und sieht
       aus, als wuerde es schrumpfen statt aufzusetzen. */
    /* 25.08.2026 GEMESSEN, Mert: "seite kaputt, mach das sauber" und
       "handy version fehler" - Titel und Preis liefen links aus dem Bild.
       Am Handy (375 px) war der Inhalt 482 px breit, also 107 px Ueberlauf.
       Der Browser bekommt dadurch eine waagerechte Bildlaufleiste und die
       ganze Seite steht seitlich verschoben.
       Drei Verursacher, alle aus dem Theme bzw. fremden Bausteinen:
         .sticky-add-to-cart__bar   fest 482,5 px statt 100 % (groesster Anteil)
         .group-block               589 px, ohne Deckel
         .st_hiw-section            405 px
       Nach diesen drei Zeilen ist der Ueberlauf gemessen 0. Die uebrigen
       breiten Elemente liegen in Bereichen mit eigenem Scrollrahmen
       (Creator-Reihe, Slider) - die sollen so bleiben. */
    P + '.sticky-add-to-cart__bar{width:100%!important;max-width:100vw!important;',
    'box-sizing:border-box!important}',
    P + '.group-block{max-width:100%!important}',
    P + '.st_hiw-section{max-width:100%!important}',
    P + '.shopify_subscriptions_fieldset{max-width:100%!important}',

    /* 28.08.2026 FESTE REGEL (Mert): "mach das untereinander, nie so - das gilt
       fuer jede seite auf mobiler ansicht."
       Gezeigt war die Zeile "OVER 10.000+ PEOPLE TR / UST US" - das Wort wurde
       mitten durchgeschnitten. Ursache ist `word-break:break-all` bzw.
       `overflow-wrap:anywhere` aus den App-Bausteinen: das erlaubt einen Bruch an
       JEDER Stelle, auch mitten im Wort.
       Richtig ist `overflow-wrap:break-word`: Woerter bleiben ganz und rutschen
       als Ganzes in die naechste Zeile; nur ein Wort, das allein breiter als die
       Zeile ist, wird noch umbrochen. Silbentrennung bleibt aus, sonst tauchen
       Bindestriche auf, die keiner gesetzt hat. */
    P + 'h1,' + P + 'h2,' + P + 'h3,' + P + 'h4,' + P + 'h5,' + P + 'h6,',
    P + '[class*="title"],' + P + '[class*="heading"],' + P + '[class*="Titel"],',
    P + 'p,' + P + 'li,' + P + 'a,' + P + 'button,' + P + 'span{',
    'word-break:normal!important;overflow-wrap:break-word!important;'+
    /* 29.08.2026, Mert: "das s darf nicht allein unten stehen, das sieht
       komisch aus" - bei "Over 10.000+ People Trust Us" rutschte das letzte
       Stueck in eine eigene Zeile. `balance` verteilt die Zeilen einer
       Ueberschrift gleichmaessig, statt die letzte Zeile mit einem Rest zu
       fuellen; wo der Browser es nicht kennt, aendert sich nichts. */
    'text-wrap:balance;'+
    'hyphens:none!important;-webkit-hyphens:none!important}',


    /* 29.08.2026, Mert: „Auf dem Handy dreht er sich nicht, nur auf pc, das ist
       ein fehler … aber er soll nicht drehen. Er soll von links nach rechts
       drehen, nicht von oben nach unten."
       Vorher stand hier `rotate(360deg)` - eine flache Drehung in der Ebene, wie
       ein Rad. Jetzt `rotateY`: das Logo dreht sich um seine Hochachse, also von
       links nach rechts wie eine Karte, die man umdreht. Die Perspektive gehoert
       in dieselbe transform-Kette; ein `perspective` am Elternteil koennte der
       Kopfbereich des Themes ueberschreiben. */
    '@keyframes mmLogoPrall{',
      '0%{opacity:0;transform:perspective(760px) translateY(-38px) scaleY(1) rotateY(0deg)}',
      '5%{opacity:1}',
      /* erster Aufprall */
      '25%{transform:perspective(760px) translateY(0) scaleY(1) rotateY(0deg);animation-timing-function:ease-out}',
      '28%{transform:perspective(760px) translateY(0) scale(1.06,.9) rotateY(0deg)}',
      /* erster Nachsprung */
      '37%{transform:perspective(760px) translateY(-14px) scale(.98,1.03) rotateY(0deg);animation-timing-function:ease-in}',
      '46%{transform:perspective(760px) translateY(0) scale(1.04,.94) rotateY(0deg);animation-timing-function:ease-out}',
      /* zweiter, kleinerer */
      '53%{transform:perspective(760px) translateY(-6px) scaleY(1.01) rotateY(0deg);animation-timing-function:ease-in}',
      '58%{transform:perspective(760px) translateY(0) scale(1.02,.97) rotateY(0deg);animation-timing-function:ease-out}',
      /* letzter Hauch */
      '62%{transform:perspective(760px) translateY(-2px) rotateY(0deg);animation-timing-function:ease-in}',
      /* Danach steht das Logo ruhig und dreht sich einmal ganz um die Hochachse.
         Bewusst EINE Animation statt einer zweiten: beide wuerden `transform`
         setzen, die zweite haette die erste ueberschrieben. */
      '66%{transform:perspective(760px) translateY(0) scaleY(1) rotateY(0deg);',
      'animation-timing-function:cubic-bezier(.5,0,.3,1)}',
      '100%{opacity:1;transform:perspective(760px) translateY(0) scaleY(1) rotateY(360deg)}}',
    '.header-logo__image,.header__heading-logo{',
    'transform-origin:center center;backface-visibility:visible;',
    'animation:mmLogoPrall 1.75s cubic-bezier(.55,.06,.68,.19) 1.15s both}',
    '@media(prefers-reduced-motion:reduce){',
    '.header-logo__image,.header__heading-logo{animation:none!important}}'
  ].join('');

  function stilblatt() {
    var v = document.getElementById('mmStil-fix');
    if (v) {
      if (v.parentNode && v.parentNode.lastElementChild !== v) v.parentNode.appendChild(v);
      return;
    }
    var s = document.createElement('style');
    s.id = 'mmStil-fix';
    s.textContent = stilCss;
    (document.head || document.documentElement).appendChild(s);
  }

  /* --- Nach-oben-Knopf verschiebbar machen --- */
  var SPEICHER = 'mmHochPos';
  function verschiebbar() {
    var h = document.getElementById('mmHoch');
    if (!h || h.dataset.mmZieh) return;
    h.dataset.mmZieh = '1';

    function setzen(x, y) {
      h.style.setProperty('left', x + 'px', 'important');
      h.style.setProperty('top', y + 'px', 'important');
      h.style.setProperty('right', 'auto', 'important');
      h.style.setProperty('bottom', 'auto', 'important');
    }
    /* gemerkte Position wiederherstellen */
    try {
      var g = JSON.parse(localStorage.getItem(SPEICHER) || 'null');
      if (g && typeof g.x === 'number') {
        setzen(Math.min(g.x, window.innerWidth - 52), Math.min(g.y, window.innerHeight - 52));
      }
    } catch (e) {}

    var zieht = false, sx = 0, sy = 0, bx = 0, by = 0, bewegt = false;

    h.addEventListener('pointerdown', function (e) {
      zieht = true; bewegt = false;
      sx = e.clientX; sy = e.clientY;
      var r = h.getBoundingClientRect();
      bx = r.left; by = r.top;
      h.classList.add('zieht');
      try { h.setPointerCapture(e.pointerId); } catch (err) {}
    });

    h.addEventListener('pointermove', function (e) {
      if (!zieht) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) bewegt = true;
      if (!bewegt) return;
      var b = h.offsetWidth || 46;
      var nx = Math.max(6, Math.min(window.innerWidth - b - 6, bx + dx));
      var ny = Math.max(6, Math.min(window.innerHeight - b - 6, by + dy));
      setzen(nx, ny);
    });

    function los(e) {
      if (!zieht) return;
      zieht = false;
      h.classList.remove('zieht');
      try { h.releasePointerCapture(e.pointerId); } catch (err) {}
      if (bewegt) {
        var r = h.getBoundingClientRect();
        try { localStorage.setItem(SPEICHER, JSON.stringify({ x: Math.round(r.left), y: Math.round(r.top) })); } catch (err) {}
      }
    }
    h.addEventListener('pointerup', los);
    h.addEventListener('pointercancel', los);

    /* nach dem Ziehen keinen Klick ausloesen */
    h.addEventListener('click', function (e) {
      if (bewegt) { e.stopImmediatePropagation(); e.preventDefault(); bewegt = false; }
    }, true);
  }

  var LUFT = 3;
  function ringeMessen() {
    [].forEach.call(document.querySelectorAll('.st_story-circle'), function (k) {
      var r = k.querySelector('.mmRing');
      if (!r) return;
      var m = k.getBoundingClientRect();
      if (!m.width) return;
      var d = Math.round(Math.max(m.width, m.height)) + LUFT * 2;
      var setz = function (n, v) { r.style.setProperty(n, v, 'important'); };
      setz('position', 'absolute');
      setz('left', (-LUFT) + 'px'); setz('top', (-LUFT) + 'px');
      setz('right', 'auto'); setz('bottom', 'auto');
      setz('width', d + 'px'); setz('height', d + 'px');
      setz('max-width', 'none'); setz('max-height', 'none');
      setz('overflow', 'visible'); setz('pointer-events', 'none');
      r.setAttribute('width', d);
      r.setAttribute('height', d);
      r.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    });
  }

  function auffrischen() { stilblatt(); ringeMessen(); verschiebbar(); }
  auffrischen();
  document.addEventListener('DOMContentLoaded', auffrischen);
  window.addEventListener('load', auffrischen);
  window.addEventListener('resize', ringeMessen, { passive: true });
  var w = 0;
  var wache = setInterval(function () {
    auffrischen();
    if (++w > 20) clearInterval(wache);
  }, 700);

  if (ruhig) return;

  var ZIELE = [
    '.mmSek .mmAuge', '.mmSek h2', '.mmSek .mmVor',
    '#mmReiter .mmRAuge', '#mmReiter h2',
    '#mmGal .mmGkopf h2', '#mmGal .mmGkopf p',
    '#mmFaq2 .mmF2auge', '#mmFaq2 h2',
    '#mmSL .mmSL-auge', '#mmSL .mmSL-fest h2',
    '#mmPx .mmPxTitel h2'
  ].join(',');

  var animCss = [
    '.mmTA{display:inline-block;white-space:pre;opacity:0;',
      'transform:translateY(16px);filter:blur(9px);',
      'transition:opacity .55s ' + K + ',transform .55s ' + K + ',filter .55s ' + K + '}',
    '.mmTA.da{opacity:1;transform:none;filter:blur(0)}'
  ].join('');

  function animStil() {
    if (document.getElementById('mmTA-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmTA-stil';
    s.textContent = animCss;
    (document.head || document.documentElement).appendChild(s);
  }

  function zerlegen(el) {
    var teile = [], neu = document.createDocumentFragment();
    [].slice.call(el.childNodes).forEach(function (kn) {
      if (kn.nodeType === 3) {
        kn.textContent.split(/(\s+)/).forEach(function (t) {
          if (t === '') return;
          var s = document.createElement('span');
          s.className = 'mmTA'; s.textContent = t;
          neu.appendChild(s);
          if (t.trim() !== '') teile.push(s);
        });
      } else if (kn.nodeName === 'BR') {
        neu.appendChild(kn);
      } else if (kn.nodeType === 1) {
        kn.classList.add('mmTA');
        neu.appendChild(kn);
        teile.push(kn);
      }
    });
    el.innerHTML = '';
    el.appendChild(neu);
    return teile;
  }

  function anbinden() {
    var el = document.querySelectorAll(ZIELE);
    if (!el.length) return false;
    animStil();
    [].forEach.call(el, function (z) {
      if (z.dataset.mmTA) return;
      z.dataset.mmTA = '1';
      if (!z.textContent.trim()) return;
      var teile = zerlegen(z);
      if (!teile.length) return;
      function alle() { teile.forEach(function (t) { t.classList.add('da'); }); }
      setTimeout(alle, 9000);
      if (!('IntersectionObserver' in window)) { alle(); return; }
      var b = new IntersectionObserver(function (e) {
        e.forEach(function (x) {
          if (!x.isIntersecting) return;
          b.disconnect();
          teile.forEach(function (t, i) {
            setTimeout(function () { t.classList.add('da'); }, i * 55);
          });
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      b.observe(z);
    });
    return true;
  }

  function versuchen() {
    var m = 0;
    anbinden();
    var t = setInterval(function () {
      anbinden();
      if (++m > 14) clearInterval(t);
    }, 800);
  }

  /* 29.08.2026, Mert: „Auf dem Handy dreht er sich nicht, nur auf pc".
     Die Animation startet 1,15 s nach dem Aufbau des Stilblattes. Am Handy ist
     das Logo zu dem Zeitpunkt oft noch gar nicht dekodiert - dann laeuft sie an
     einem leeren Bild ab und niemand sieht sie. Deshalb wird sie hier EINMAL neu
     angestossen, sobald das Bild wirklich da ist. `style.animation=''` gibt die
     Regel aus dem Stilblatt zurueck, samt Verzoegerung - es laeuft also der
     vollstaendige Ablauf, nicht nur die Drehung. */
  function logoStarten() {
    var l = document.querySelector('.header-logo__image, .header__heading-logo');
    if (!l || l.dataset.mmLogo) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    l.dataset.mmLogo = '1';
    var los = function () {
      window.setTimeout(function () {
        l.style.animation = 'none';
        void l.offsetWidth;
        l.style.animation = '';
      }, 80);
    };
    if (l.tagName !== 'IMG' || l.complete) los();
    else l.addEventListener('load', los, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { versuchen(); logoStarten(); });
  } else { versuchen(); logoStarten(); }
  window.addEventListener('load', function () { versuchen(); logoStarten(); });
})();
